module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_1.c7278fa6.png";